// Font Size Constants
export const CONTENT_FONT_SIZE = 16 as const
export const DEFAULT_LINE_HEIGHT = 20 as const
